<template>
  <div class="room ventilation" v-loading="loadingData">
    <RefreshBlock @refreshData="refreshData"></RefreshBlock>
    <div class="device-block-multi">
      <div class="air-wrap" :class="warningFlagLeft">
        <div class="air-title">{{ airWrapTitleLeft }}</div>
        <div class="air-chart-wrap">
          <div class="air-chart">
            <single-histogram
              :opts="singleHisOpts1"
              :series="singleHisData1"
            ></single-histogram>
          </div>
          <div class="air-chart">
            <single-histogram
              :opts="singleHisOpts2"
              :series="singleHisData2"
            ></single-histogram>
          </div>
          <div class="air-chart">
            <single-histogram
              :opts="singleHisOpts3"
              :series="singleHisData3"
            ></single-histogram>
          </div>
        </div>
      </div>

      <div class="air-wrap" :class="warningFlagRight">
        <div class="air-title">{{ airWrapTitleRight }}</div>
        <div class="air-chart-wrap">
          <SinglePieHistogramWrap
            class="device-block-multi-item"
            :opts="singlePieHistogramWrapOpts1"
            :series="singlePieHistogramWrapData1"
            :class="singlePieHistogramWarningFlag1"
          ></SinglePieHistogramWrap>
          <SinglePieHistogramWrap
            class="device-block-multi-item"
            :opts="singlePieHistogramWrapOpts2"
            :series="singlePieHistogramWrapData2"
            :class="singlePieHistogramWarningFlag2"
          ></SinglePieHistogramWrap>
        </div>
      </div>
    </div>

    <div class="device-block-line">
      <div class="device-block-line-item">
        <div class="device-block-line-item-top">
          <div class="device-block-line-item-half">
            <SwitchStatus
              class="switch-item"
              :title="switchTitleLeft1"
              :series="switchDataLeft1"
            ></SwitchStatus>
            <SwitchStatus
              class="switch-item"
              :title="switchTitleLeft2"
              :series="switchDataLeft2"
            ></SwitchStatus>
            <SwitchStatus
              class="switch-item"
              :title="switchTitleLeft3"
              :series="switchDataLeft3"
            ></SwitchStatus>
            <SwitchStatus
              class="switch-item"
              :title="switchTitleLeft4"
              :series="switchDataLeft4"
            ></SwitchStatus>
          </div>
          <div class="device-block-line-item-half">
            <SwitchStatus
              class="switch-item"
              :title="switchTitleLeft5"
              :series="switchDataLeft5"
            ></SwitchStatus>
            <SwitchStatus
              class="switch-item"
              :title="switchTitleLeft6"
              :series="switchDataLeft6"
            ></SwitchStatus>
            <SwitchStatus
              class="switch-item"
              :title="switchTitleLeft7"
              :series="switchDataLeft7"
            ></SwitchStatus>
            <SwitchStatus
              class="switch-item"
              :title="switchTitleLeft8"
              :series="switchDataLeft8"
            ></SwitchStatus>
          </div>
        </div>
        <RunningTimeBig
          class="running-time-item-left"
          :title="runningTimeTitleLeft"
          :series="runningTimeDataLeft"
        ></RunningTimeBig>
      </div>

      <div class="device-block-line-item">
        <div class="device-block-line-item-top">
          <div class="device-block-line-item-half">
            <SwitchStatus
              class="switch-item"
              :title="switchTitleRight1"
              :series="switchDataRight1"
            ></SwitchStatus>
            <!-- <SwitchStatus
              class="switch-item"
              :title="switchTitleRight2"
              :series="switchDataRight2"
            ></SwitchStatus> -->
            <SwitchStatus
              class="switch-item"
              :title="switchTitleRight3"
              :series="switchDataRight3"
            ></SwitchStatus>
            <SwitchStatus
              class="switch-item"
              :title="switchTitleRight4"
              :series="switchDataRight4"
            ></SwitchStatus>
          </div>
          <div class="device-block-line-item-half">
            <SwitchStatus
              class="switch-item"
              :title="switchTitleRight5"
              :series="switchDataRight5"
            ></SwitchStatus>
            <!-- <SwitchStatus
              class="switch-item"
              :title="switchTitleRight6"
              :series="switchDataRight6"
            ></SwitchStatus> -->
            <SwitchStatus
              class="switch-item"
              :title="switchTitleRight7"
              :series="switchDataRight7"
            ></SwitchStatus>
            <SwitchStatus
              class="switch-item"
              :title="switchTitleRight8"
              :series="switchDataRight8"
            ></SwitchStatus>
          </div>
        </div>
        <RunningTimeBig
          class="running-time-item-right"
          :title="runningTimeTitleRight"
          :series="runningTimeDataRight"
        ></RunningTimeBig>
      </div>
    </div>
  </div>
</template>

<script>
import configJson from './config/stationSettingConfig.json';

export default {
  name: 'ventilationNew',
  data() {
    return {
      timer: null,
      loading: false,
      loadingData: false,

      deviceList: [],
      deviceLeftName: '',
      deviceRightName: '',

      singleHisOpts1: {
        title: '湿度',
        histogramName1: 'RH',
        max: 80,
        sign: '%',
      },
      singleHisOpts2: {
        title: '温度',
        histogramName1: 'T',
        max: 80,
        sign: '℃',
      },
      singleHisOpts3: { title: '压力', histogramName1: 'Pa', max: 100 },

      switchTitleLeft1: '上游中效过滤堵塞',
      switchTitleLeft2: '制备站自动运行',
      switchTitleLeft3: '上游送风暂停',
      switchTitleLeft4: '除湿机运行',

      switchTitleLeft5: '上游布袋过滤堵塞',
      switchTitleLeft6: '系统报警',
      switchTitleLeft7: '新风堵塞',
      switchTitleLeft8: '除湿机故障',

      runningTimeTitleLeft: '除湿机运行时间',

      switchTitleRight1: '下游中效过滤堵塞',
      switchTitleRight2: '制备站自动运行',
      switchTitleRight3: '下游送风暂停',
      switchTitleRight4: '空调器运行',

      switchTitleRight5: '下游布袋过滤堵塞',
      switchTitleRight6: '系统报警',
      switchTitleRight7: '热回收堵塞',
      switchTitleRight8: '空调器故障',

      runningTimeTitleRight: '空调器运行时间',

      singleHisData1: {},
      singleHisData2: {},
      singleHisData3: {},

      singlePieHistogramWrapData1: {},
      singlePieHistogramWrapData2: {},

      singlePieHistogramWarningFlag1: '',
      singlePieHistogramWarningFlag2: '',

      airWrapWarningFlag: '',

      switchDataLeft1: {},
      switchDataLeft2: {},
      switchDataLeft3: {},
      switchDataLeft4: {},
      switchDataLeft5: {},
      switchDataLeft6: {},
      switchDataLeft7: {},
      switchDataLeft8: {},
      switchDataRight1: {},
      switchDataRight2: {},
      switchDataRight3: {},
      switchDataRight4: {},
      switchDataRight5: {},
      switchDataRight6: {},
      switchDataRight7: {},
      switchDataRight8: {},
      runningTimeDataLeft: '',
      runningTimeDataRight: '',

      warningFlagLeft: '',
      warningFlagRight: '',
    };
  },
  computed: {
    singlePieHistogramWrapOpts1: function () {
      return {
        title: '送气站温湿度设定',
        histogramName1: 'T',
        center1: ['52%', '60%'],
        radius1: ['40%', '55%'],
        pieName1: 'RH',
        max: 50,
        pieMax: 100,
        toprichFontSize: 18,
        topFontSize: 20,
        sign: '°C',
      };
    },
    singlePieHistogramWrapOpts2: function () {
      return {
        title: '室外新风温湿度',
        histogramName1: 'T',
        center1: ['52%', '60%'],
        radius1: ['40%', '55%'],
        pieName1: 'RH',
        max: 50,
        pieMax: 100,
        toprichFontSize: 18,
        topFontSize: 20,
        sign: '°C',
      };
    },
    airWrapTitleLeft() {
      return this.bridgeSegmentName + '制备站内工况';
    },
    airWrapTitleRight() {
      return this.bridgeSegmentName + '制备站功能设定';
    },
  },
  created() {
    this.readConfig();
  },
  mounted() {
    this.getData();
    this.timer = setInterval(() => {
      this.getData();
    }, this.REFRESH_SECOND);
  },
  watch: {
    /**
     * 监听路由变化
     * @param {Object} route # 当前路由信息
     */
    $route(route) {
      this.resetData();
      this.readConfig();
      this.loadingData = true;
      this.getData();
    },
  },
  methods: {
    readConfig() {
      const routerPath = this.$route.fullPath.split('/');
      this.deviceList = configJson[routerPath[3]].deviceList;
      // const deviceName = configJson[routerPath[3]].deviceName;
      // this.deviceLeftName = deviceName.deviceLeftName;
      // this.deviceRightName = deviceName.deviceRightName;
      this.stationId = configJson[routerPath[3]].stationId;
      this.bridgeSegmentName = configJson[routerPath[3]].bridgeSegmentName;
    },
    resetData() {
      this.warningFlagLeft = '';
      this.warningFlagRight = '';
    },
    refreshData() {
      this.loadingData = true;
      this.getData();
      clearInterval(this.timer);
      this.timer = setInterval(() => {
        this.getData();
      }, this.REFRESH_SECOND);
    },
    findDeviceId(deviceName) {
      const device = this.deviceList.find((el) => {
        return el.deviceName === deviceName;
      });
      if (!device) {
        console.log(`deviceName${deviceName}###`);
      }
      return device.deviceId || '';
    },
    getCurrentData(stationId) {
      return this.$http.get(`/deviceData/Station?stationId=${stationId}`);
    },
    getData() {
      this.getCurrentData(this.stationId).then((res) => {
        setTimeout(() => {
          this.loadingData = false;
        }, 500);

        const currentData = res.data;
        this.setAirWrapData(
          currentData,
          this.deviceIdListLeft,
          '送气站湿度',
          '送气站温度',
          '送气站压力',
          'singleHisData1',
          'singleHisData2',
          'singleHisData3',
          'airWrapWarningFlag'
        );

        this.setPieHistogramDataAndError(
          currentData,
          'singlePieHistogramWrapData1',
          '送气站温度设定',
          '送气站湿度设定',
          'singlePieHistogramWarningFlag1'
        );
        this.setPieHistogramDataAndError(
          currentData,
          'singlePieHistogramWrapData2',
          '新风温度',
          '新风湿度',
          'singlePieHistogramWarningFlag2'
        );

        const switchIdLeft1 = this.findDeviceId(this.switchTitleLeft1);
        const switchIdLeft2 = this.findDeviceId(this.switchTitleLeft2);
        const switchIdLeft3 = this.findDeviceId(this.switchTitleLeft3);
        const switchIdLeft4 = this.findDeviceId(this.switchTitleLeft4);
        const switchIdLeft5 = this.findDeviceId(this.switchTitleLeft5);
        const switchIdLeft6 = this.findDeviceId(this.switchTitleLeft6);
        const switchIdLeft7 = this.findDeviceId(this.switchTitleLeft7);
        const switchIdLeft8 = this.findDeviceId(this.switchTitleLeft8);

        this.switchDataLeft1 = {
          data: currentData[switchIdLeft1].value,
          isError: currentData[switchIdLeft1].errorLevel,
          isZh: true,
        };
        this.switchDataLeft2 = {
          data: currentData[switchIdLeft2].value,
          isError: currentData[switchIdLeft2].errorLevel,
        };
        this.switchDataLeft3 = {
          data: currentData[switchIdLeft3].value,
          isError: currentData[switchIdLeft3].errorLevel,
          isZh: true,
        };
        this.switchDataLeft4 = {
          data: currentData[switchIdLeft4].value,
          isError: currentData[switchIdLeft4].errorLevel,
        };
        this.switchDataLeft5 = {
          data: currentData[switchIdLeft5].value,
          isError: currentData[switchIdLeft5].errorLevel,
          isZh: true,
        };
        this.switchDataLeft6 = {
          data: currentData[switchIdLeft6].value,
          isError: currentData[switchIdLeft6].errorLevel,
          isZh: true,
        };
        this.switchDataLeft7 = {
          data: currentData[switchIdLeft7].value,
          isError: currentData[switchIdLeft7].errorLevel,
          isZh: true,
        };
        this.switchDataLeft8 = {
          data: currentData[switchIdLeft8].value,
          isError: currentData[switchIdLeft8].errorLevel,
          isZh: true,
        };

        const switchIdRight1 = this.findDeviceId(this.switchTitleRight1);
        const switchIdRight2 = this.findDeviceId(this.switchTitleRight2);
        const switchIdRight3 = this.findDeviceId(this.switchTitleRight3);
        const switchIdRight4 = this.findDeviceId(this.switchTitleRight4);
        const switchIdRight5 = this.findDeviceId(this.switchTitleRight5);
        const switchIdRight6 = this.findDeviceId(this.switchTitleRight6);
        const switchIdRight7 = this.findDeviceId(this.switchTitleRight7);
        // const switchIdRight8 = this.findDeviceId(this.switchTitleRight8);

        this.switchDataRight1 = {
          data: currentData[switchIdRight1].value,
          isError: currentData[switchIdRight1].errorLevel,
          isZh: true,
        };
        this.switchDataRight2 = {
          data: currentData[switchIdRight2].value,
          isError: currentData[switchIdRight2].errorLevel,
        };
        this.switchDataRight3 = {
          data: currentData[switchIdRight3].value,
          isError: currentData[switchIdRight3].errorLevel,
          isZh: true,
        };
        this.switchDataRight4 = {
          data: currentData[switchIdRight4].value,
          isError: currentData[switchIdRight4].errorLevel,
        };
        this.switchDataRight5 = {
          data: currentData[switchIdRight5].value,
          isError: currentData[switchIdRight5].errorLevel,
          isZh: true,
        };
        this.switchDataRight6 = {
          data: currentData[switchIdRight6].value,
          isError: currentData[switchIdRight6].errorLevel,
          isZh: true,
        };
        this.switchDataRight7 = {
          data: currentData[switchIdRight7].value,
          isError: currentData[switchIdRight7].errorLevel,
          isZh: true,
        };
        this.switchDataRight8 = {
          data: 0,
          isError: 0,
          isZh: true,
        };

        const runningTimeIdLeft = this.findDeviceId(
          this.runningTimeTitleLeft,
          this.deviceIdList
        );
        this.runningTimeDataLeft = currentData[runningTimeIdLeft].value;

        const runningTimeIdRight = this.findDeviceId(
          this.runningTimeTitleRight,
          this.deviceIdList
        );
        this.runningTimeDataRight = currentData[runningTimeIdRight].value;
      });
    },

    setAirWrapData(
      currentData,
      deviceIdList,
      singleHisDeviceName1,
      singleHisDeviceName2,
      singleHisDeviceName3,
      singleHisDataName1,
      singleHisDataName2,
      singleHisDataName3,
      errorName
    ) {
      const singleHisDeviceId1 = this.findDeviceId(singleHisDeviceName1);
      const singleHisDeviceId2 = this.findDeviceId(singleHisDeviceName2);
      const singleHisDeviceId3 = this.findDeviceId(singleHisDeviceName3);

      this[singleHisDataName1] = {
        data: currentData[singleHisDeviceId1].value,
      };
      this[singleHisDataName2] = {
        data: currentData[singleHisDeviceId2].value,
      };
      this[singleHisDataName3] = {
        data: currentData[singleHisDeviceId3].value,
      };

      this[errorName] = this.getErrorLevelFromMultipleDevice(
        this[errorName],
        currentData[singleHisDeviceId1].errorLevel
      );
      this[errorName] = this.getErrorLevelFromMultipleDevice(
        this[errorName],
        currentData[singleHisDeviceId2].errorLevel
      );
      this[errorName] = this.getErrorLevelFromMultipleDevice(
        this[errorName],
        currentData[singleHisDeviceId3].errorLevel
      );
    },

    setPieHistogramDataAndError(
      currentData,
      echartSeriesDataName,
      temperatureName,
      humidityName,
      warningFlagName
    ) {
      const temperatureId = this.findDeviceId(temperatureName);
      const humidityId = this.findDeviceId(humidityName);
      this[echartSeriesDataName] = {
        data1: currentData[temperatureId].value,
        data2: currentData[humidityId].value,
      };

      let errorLevel = this.getErrorLevelFromMultipleDevice(
        currentData[temperatureId].errorLevel,
        this[warningFlagName]
      );
      errorLevel = this.getErrorLevelFromMultipleDevice(
        currentData[humidityId].errorLevel,
        this[warningFlagName]
      );
      this[warningFlagName] = errorLevel;
    },

    getErrorLevelFromMultipleDevice(newErrorLevel, currentErrorLevel) {
      if (currentErrorLevel === 'Error') {
        return 'Error';
      } else if (currentErrorLevel === 'Warning') {
        if (newErrorLevel === 'Error') {
          return 'Error';
        } else {
          return 'Warning';
        }
      } else {
        return newErrorLevel;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.ventilation {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  align-items: stretch;
  align-content: stretch;
  padding-top: 10px;

  .device-block-multi {
    width: 100%;
    height: calc(50% - 15px);
    background-color: transparent;
    display: flex;
    justify-content: space-between;
    align-items: stretch;

    .device-block {
      width: calc(50% - 10px);
      height: 100%;
      display: flex;
      justify-content: space-between;
      align-items: stretch;
      position: relative;

      .device-block-line-chart {
        width: 75%;
        height: 100%;
      }

      .device-block-bar-chart {
        width: 24%;
        height: 100%;
      }
    }
  }

  .device-block-line {
    width: 100%;
    height: calc(50% - 15px);
    background-color: transparent;
    display: flex;
    justify-content: space-between;
    align-items: stretch;

    .device-block-line-item {
      width: calc(50% - 9px);
      display: flex;
      box-sizing: border-box;
      justify-content: space-between;
      flex-direction: column;
      align-items: stretch;

      .device-block-line-item-half {
        display: flex;
        height: 100%;
        width: calc(50% - 7px);
        flex-direction: column;
        justify-content: space-between;
      }

      .device-block-line-item-top {
        display: flex;
        justify-content: space-between;
        height: 60px;
        width: 100%;
      }

      .switch-item {
        height: 38px;
        width: 100%;
        box-sizing: border-box;
        flex-shrink: 0;
        margin-bottom: 10px;
        &:last-child {
          margin-bottom: 0;
        }
      }

      .running-time-item-left {
        height: calc(100% - 195px);
        width: 100%;
        box-sizing: border-box;
      }

      .running-time-item-right {
        height: calc(100% - 148px);
        width: 100%;
        box-sizing: border-box;
      }

      &.single-chart-item {
        background-color: rgba(255, 255, 255, 0.6);
      }
    }
  }

  .air-wrap {
    box-shadow: 0 2px 3px 0 rgba(0, 0, 0, 0.2);
    display: flex;
    flex-direction: column;
    padding: 0 10px;
    width: calc(50% - 10px);
    height: 100%;
    background-color: rgba(255, 255, 255, 0.6);
    box-sizing: border-box;

    .air-title {
      padding: 20px 15px 10px 10px;
      font-size: 22px;
      color: #515151;
    }

    .air-chart-wrap {
      display: flex;
      flex: 1;
    }

    .air-chart {
      padding: 20px 0;
      box-sizing: border-box;
      width: 33.3333%;
    }
  }
}
</style>
